<template>
<div class="chapter">
<div class="inner_page">
<p class="ded"><a id="page_v">To my one-year-old nephew Isaac, in whose eyes I see the world reflected, and find it to be wondrous and full of surprises</a><a id="page_vi"></a></p><a id="page_vi">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ded.vue?077bfa8a